import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { CloudImage, PlaceholderCloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { defaultBase64Placeholder } from '@components/CloudImage';

export const StyledUniversalRegistry = styled(Box)`
  position: relative;
  min-height: 700px;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const UniversalRegistryGraphicWrapper = styled(Box)`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 1200px;
`;

export const StyledGoldThread1 = styled(PlaceholderCloudImage)`
  position: absolute;
  height: 100%;
`;

export const StyledGoldThreadBack = styled(Flex)`
  position: relative;
  width: 100%;
  height: 800px;
  ${themeMediaQuery('below_sm')} {
    height: 350px;
    display: none;
  }
`;

export const StyledSVGWrapper = styled.svg`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledMainFlex = styled(Flex)`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const StyledImagesRow = styled(Flex)`
  position: absolute;
  justify-content: space-between;
  width: 100%;
  top: 0px;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledImagesRow2 = styled(Flex)`
  position: absolute;
  justify-content: flex-end;
  width: 100%;
  bottom: 0px;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const ClipPathBox = styled(Box)<{
  id: string;
  width: string;
  height: string;
  clipId: string;
  imgUrl: string;
  bkgSize: string;
  bkgPosition: string;
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}>`
  position: relative;
  top: ${props => (props.top ? props.top + 'px' : undefined)};
  bottom: ${props => (props.bottom ? props.bottom + 'px' : undefined)};
  left: ${props => (props.left ? props.left + 'px' : undefined)};
  right: ${props => (props.right ? props.right + 'px' : undefined)};
  width: ${props => props.width};
  height: ${props => props.height};
  clip-path: url(#${props => props.clipId});
  background-image: url(${props => props.imgUrl});
  background-size: ${props => props.bkgSize};
  background-position: ${props => props.bkgPosition};
  z-index: 9;
  background-repeat: no-repeat;
  #${props => props.id} {
    clip-path: url(${props => props.clipId});
  }
`;

export const StyledCenterImageShape = styled(Flex)<{
  imageSrc: string;
}>`
  background: url(${props => cloudAssetUrl(props.imageSrc)});
  background-repeat: no-repeat;
  background-size: cover;
  width: 650px;
  height: 450px;
  border-radius: 25px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  overflow: hidden;
  z-index: 1;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: 550px;
  }
`;

export const StyledCenterImage = styled(Box)<{ imageSrc: string; isScrolledIntoView: boolean }>`
  background: url(${({ isScrolledIntoView, imageSrc }) => (isScrolledIntoView ? cloudAssetUrl(imageSrc) : defaultBase64Placeholder)});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 690px;
  height: 1070px;
  z-index: -1;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: 750px;
    background-size: cover;
  }
`;

export const BrowserImageWrapper = styled(Box)`
  width: 690px;
  height: 450px;
  background-color: #ffffff;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: 550px;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 308px;
    margin-bottom: ${themeSpace(6)};
  }
  .text-pairing-body {
    max-width: 391px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 246px;
    }
    .text-pairing-body {
      max-width: 280px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 400px;
    }
    .text-pairing-body {
      max-width: 460px;
    }
  }
`;

export const LottiesContainer = styled(Flex)`
  gap: ${themeSpace(9)};
  justify-content: space-between;
  ${themeMediaQuery('below_sm')} {
    gap: ${themeSpace(6)};
  }
  @media (max-width: 1024px) and (min-width: 768px) {
    gap: ${themeSpace(9)};
  }
`;

export const StateIconTextContainer = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StateIconLottie = styled.div`
  width: 96px;
  height: 96px;
  ${themeMediaQuery('below_sm')} {
    width: 70px;
    height: 70px;
  }
`;

export const IconTextPairing = styled(TextPairing)`
  .text-pairing-title {
    ${themeMediaQuery('below_sm')} {
      font-size: 14px;
    }
  }
`;

export const HeroTextContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
`;

export const StyledMobileImage = styled(CloudImage)`
  object-fit: contain;
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const StyledHeroTextColumn = styled(Columns)`
  ${themeMediaQuery('sm')} {
    max-width: 55rem;
  }
  ${themeMediaQuery('lg')} {
    max-width: 90rem;
  }
`;
